import { isRequired } from 'utils/validators';
import { TRANSLATIONS } from 'translations/index';

const SECOND_LANGUAGE = 'Norwegian';

const validate = values => {
  const errors = {};

  if (isRequired(values[`title`] || '', true)) {
    errors[`title`] = TRANSLATIONS[SECOND_LANGUAGE].titleIsRequired;
  }

  return errors;
};

export default validate;